import React, { useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { DraggableModalDialog } from './DraggableModalDialog';

function CommentDialog({ showDialog, closeDialog, onSave}) {
    const [comment, setComment] = useState("");

    const onChange = (e) => {
        setComment(e.currentTarget.value);
    }

    const handleSave = (e) => {
        e.preventDefault();
        e.stopPropagation();

        onSave(comment);
        closeDialog();
    }
    
    return (
        <Modal dialogAs={DraggableModalDialog} show={showDialog} onHide={closeDialog} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Comment</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSave} id="commentForm">
                    <Form.Control as="textarea" rows="6" value={comment} onChange={onChange} />
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeDialog}>
                    Close
                </Button>
                <Button variant="primary" type="submit" form="commentForm">
                    Save
                </Button>
            </Modal.Footer>
        </Modal>

    );
}

export default CommentDialog;